export const forgot_password_style = {
  rootSx: {
    backgroundColor: '#F3F0FF',
  },
  imgContSx: {
    py: 3.5,
  },
};
